import translate from '@translate';
import React, { FC, useEffect, useState } from 'react';
import TableSimple from 'src/components/TableSimple';
import Typography from 'src/components/Typography';
import { sizes } from 'src/themes/default';
import { OrderExpeditionPackageType } from 'src/types/orderDetail';
import { expeditionPackagesAllColumns } from './constants';

interface RowOrderExpeditionPackageType extends OrderExpeditionPackageType {
    idRow: string;
    product_SKU?: string;
    product_SERIAL_NUMBER?: string;
    product_COUNT?: number;
    product_NAME?: string;
    product_EAN?: string;
    product_LOT?: string;
    product_EXP_DATE?: string;
}

export interface ExpeditionPackagesTablePropsType {
    data?: OrderExpeditionPackageType[] | null;
}

const ExpeditionPackagesTable: FC<ExpeditionPackagesTablePropsType> = (props) => {
    const [data, setData] = useState<RowOrderExpeditionPackageType[]>([]);

    useEffect(() => {
        if (props.data) {
            const newData: RowOrderExpeditionPackageType[] = [];

            props.data.forEach((item, index) => {
                newData.push({
                    ...item,
                    idRow: `${index}`,
                    product_SKU: item.SKU,
                    product_SERIAL_NUMBER: item.SERIAL_NUMBER,
                    product_COUNT: item.COUNT,
                    product_NAME: item.NAME,
                    product_EAN: item.EAN,
                    product_LOT: item.LOT,
                    product_EXP_DATE: item.EXP_DATE,
                });
            });
            setData(newData);
        }
    }, [props.data]);

    if (!data.length) {
        return (
            <Typography variant="h2" align="center" sx={{ marginTop: sizes.blocks_top_MG }}>
                {translate('orderDetail.emptyData')}
            </Typography>
        );
    }

    return (
        <TableSimple
            rowIdKey="idRow"
            rows={data || []}
            columsLabelPrefix="orderDetail.expeditionPackagesTable"
            allColumns={expeditionPackagesAllColumns}
            initSort={{ column: 'ID', direction: 'ASC', createIdNumber: true }}
            heightVariant="top-tab"
        />
    );
};

export default ExpeditionPackagesTable;
